import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import FilledButton from 'components/application/buttons/FilledButton';
import TextButton from 'components/application/buttons/TextButton';
import ModalBox from 'components/application/ModalBox';

export default function ResendInviteModal({
  email,
  firstName,
  onClose,
  onResend,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'settings.users.ResendInviteModal',
  });

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <ModalBox
      customFooter={
        <div className='modalbox__footer-actions modalbox__footer-actions--right'>
          <TextButton
            className='tw-mr-3'
            color='blue'
            onClick={onClose}
            size='md'
          >
            {i18nTShared('cancel')}
          </TextButton>
          <FilledButton color='red' onClick={onResend}>
            {i18nTShared('resend')}
          </FilledButton>
        </div>
      }
      isOpen={true}
      mode='letterbox'
      onClose={onClose}
      usingStandardDimensions={true}
    >
      <>
        <div className='modalbox-header tw-border-grey-100'>
          <h2 className='modalbox-header__title truncated-text-container tw-text-l tw-font-semibold tw-text-grey-900'>
            {i18nT('title', {
              interpolation: { escapeValue: false },
              name: firstName,
            })}
          </h2>
        </div>
        <div className='modalbox-body'>
          {i18nT('description', {
            email,
            interpolation: { escapeValue: false },
          })}
        </div>
      </>
    </ModalBox>
  );
}

ResendInviteModal.propTypes = {
  email: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onResend: PropTypes.func.isRequired,
};
